const DottedSpinner = () => (
    <div className="dotted-spinner-container">
        <div className="dotted-spinner"></div>
    </div>
);
export default DottedSpinner;
